import React from "react"
import ReactDOMServer from "react-dom/server"

// Joins each text node with a space rather than concatenating body.textContent
// directly, since diagrams render many adjacent SVG <text> elements with no
// whitespace between them (otherwise "Client" + "Server" reads as "ClientServer").
function collectText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
    const parts = []
    let node
    while ((node = walker.nextNode())) {
        const value = node.nodeValue.trim()
        if (value) parts.push(value)
    }
    return parts.join(' ')
}

// Renders a page component off-screen to pull out its visible text for search indexing.
// Pages that depend on context this render doesn't provide (router, auth) are skipped
// rather than crashing the index build.
export default function extractPageText(Component) {
    try {
        const html = ReactDOMServer.renderToStaticMarkup(<Component/>)
        const body = new DOMParser().parseFromString(html, 'text/html').body
        return collectText(body).replace(/\s+/g, ' ').trim()
    } catch (e) {
        return ''
    }
}
